import { Euler, Vector3 } from "three";
import { engineRequestAfter } from "../../util/EngineUtils.js";
import { CSS3DObjectElement } from "./CSS3DObjectElement.js";

export function instantiateInputElement() {
  const container = document.createElement("div");
  const input = document.createElement("input");
  input.style.position = "absolute";
  input.style.backgroundColor = "#fdfdfd";
  input.style.color = "#494949";
  input.style.padding = "2.5px";
  input.style.fontSize = "12.56px";
  input.style.fontWeight = "300";
  input.style.fontFamily = '"DM Sans", sans-serif';
  input.style.lineHeight = "100%";
  input.style.letterSpacing = "0px";
  input.style.whiteSpace = "nowrap";
  input.style.transform = "translate(-50%, -50%)";
  input.style.pointerEvents = "auto";
  input.style.borderWidth = "1.0px";
  input.style.borderColor = "rgb(47 119 86 / 35%)";
  input.style.borderRadius = "3.96px";
  //input.style.minWidth = "45px";

  input.value = "1000mm";

  //tricky
  const span = document.createElement("span");
  span.style.position = "absolute";
  span.style.left = "-9999px";
  span.style.top = "-9999px";
  span.style.zIndex = "9";
  span.style.padding = "2.5px";
  span.style.display = "inline-block";
  span.style.fontSize = "12.56px";
  span.style.fontWeight = "300";
  span.style.fontFamily = '"DM Sans", sans-serif';
  span.style.whiteSpace = "nowrap";
  span.style.borderWidth = "1.0px";
  span.style.borderColor = "black";
  span.style.borderRadius = "3.96px";
  span.style.lineHeight = "100%";
  span.style.letterSpacing = "0px";

  //span.style.minWidth = "45px";
  span.innerHTML = "9999mm";

  input.addEventListener("keyup", (e) => {
    span.innerHTML = input.value.replace(/\s/g, "&nbsp;");
    engineRequestAfter(() => {
      if (span.offsetWidth > 0) input.style.width = span.offsetWidth + "px";
    });
  });

  input.addEventListener("focus", (event: FocusEvent) => {
    const inputElement = event.target as HTMLInputElement;
    inputElement.select();
    event.preventDefault();
  });

  input.addEventListener("keypress", (event: KeyboardEvent) => {
    if (event.key === "Enter") {
      return;
    }
    const startIndex = (event.target as any).selectionStart;
    const endindex = (event.target as any).selectionEnd;

    const candidate =
      input.value.slice(0, startIndex) +
      event.key +
      input.value.slice(endindex);

    const regex = /^\s*(\d*)\s*((c{1}m{1}){0,1}|(m){0,2})$/;
    const mathes = regex.exec(candidate);

    if (mathes && mathes[1]) {
      if (mathes[2] === "") {
        input.value = "mm";
        input.setSelectionRange(mathes[1].length - 1, mathes[1].length - 1);
      }
    } else {
      event.preventDefault();
    }
  });

  container.appendChild(input);
  container.appendChild(span);

  return container;
}

export class CSS3DObjectInput extends CSS3DObjectElement {
  constructor(
    name: string,
    options: {
      minScale?: number;
      maxScale?: number;
      rotation?: Euler;
      scale?: Vector3;
      debug?: boolean;
    } = {
      minScale: -1,
      maxScale: -1,
      rotation: new Euler(),
      scale: new Vector3(1, 1, 1),
      debug: false,
    }
  ) {
    super(instantiateInputElement(), name, options);
  }

  round(value: number) {
    if (Math.abs(value) < 0.0001) {
      return 0;
    }
    return value;
  }

  addInputEventListener<T extends keyof HTMLElementEventMap>(
    type: T,
    listener: (event: HTMLElementEventMap[T]) => void
  ): void {
    this.input.addEventListener(
      type,
      listener as EventListenerOrEventListenerObject
    );
  }

  dispatchInputEventListener(event: Event) {
    this.input.dispatchEvent(event);
  }

  get input() {
    return this._object!.element.children[0] as HTMLInputElement;
  }

  get span() {
    return this._object!.element.children[1] as HTMLSpanElement;
  }

  get value() {
    return this.input.value;
  }

  set value(value: string) {
    this.input.value = value;
    this.span.innerHTML = value.replace(/\s/g, "&nbsp;");
    engineRequestAfter(this.run.bind(this));
  }

  run() {
    if (this.span.offsetWidth > 0)
      this.input.style.width = this.span.offsetWidth + "px";
  }
}
